import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Checkbox,
  CircularProgress,
} from "@mui/material";

// Custom Table component used across application to display tables
const CustomTable = ({
  columns,
  data,
  page,
  count,
  rowPerPage,
  handlePageChange,
  handleRowsPerPageChange,
  handleRowClick,
  hover = false,
  showCheckBox = false,
  handleCheckBox,
  selected = [],
  hidePagination = false,
  isLoading = false,
  maxWidth = '100%'
}) => {
  const isSelected = (id) => selected.indexOf(id) !== -1;
  // Styles for reduced padding, smaller font size, and cell spacing
  const cellStyles = {
    padding: "4px 8px", // Adjust as needed
    fontSize: "10px", // Smaller font size
    lineHeight: '1.2',
    border: '1px solid white', // Add white border around cells
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 250, maxWidth: maxWidth }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow style={{backgroundColor: '#00555C'}}>

              {showCheckBox && <TableCell></TableCell>}

              {columns?.map((col, index) => (
                <TableCell
                  key={index}
                  align={col.align ?? "center"}
                  style={{ ...cellStyles, minWidth: col.minWidth, width: col.width, backgroundColor: '#00555C', color: 'white' }}
                >
                  <b>{col.name ?? ""}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <TableBody>
              {data?.map((row, rowIndex) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${rowIndex}`;
                return (
                  <TableRow
                    key={`row-${rowIndex}`}
                    hover={hover}
                    onClick={(event) =>
                      handleRowClick ? handleRowClick(event, row) : undefined
                    }
                    style={{backgroundColor: '#f5f5f5'}}
                  >
                    {showCheckBox && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          onChange={(event) =>
                            handleCheckBox ? handleCheckBox(event, row) : undefined
                          }
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                          style={cellStyles}
                        />
                      </TableCell>
                    )}
                    {columns?.map((col, colIndex) => (
                      <TableCell
                        key={`cell-${rowIndex}-${colIndex}`}
                        align={col.align ?? "center"}
                        style={cellStyles}
                      >
                        {/* {console.log('col.id:', col.id, 'row[col.id]:', row[col.id])} */}
                        {col.element ? col.element(row) : row[col.id] == 0 || row[col.id] == 0.0 ? '0.0' : row[col.id] ? row[col.id] : '...'}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {!hidePagination && (
        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={rowPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}
    </>
  );
};

export default CustomTable;
